import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ChartHorizontalIcon, PercentIcon } from '@edusynch/edusynch-svg-icons';

const toggleButtonStyles = {
  width: '4.8rem',
  height: '2.4rem',
};

export const ChartToggle = ({ activeView, onToggle }) => {
  const theme = useTheme();

  const handleChange = (_, newView) => {
    if (newView !== null) {
      onToggle(newView);
    }
  };

  return (
    <ToggleButtonGroup
      value={activeView}
      exclusive
      size="large"
      onChange={handleChange}
    >
      <ToggleButton
        value="line"
        aria-label="line-chart"
        size="small"
        sx={{
          ...toggleButtonStyles,
          borderTopLeftRadius: '2.4rem',
          borderBottomLeftRadius: '2.4rem',
          '&:hover': {
            backgroundColor: theme.config.colors.primary_100,
          },
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: theme.config.colors.primary_100,
            'svg path': {
              fill: theme.config.colors.primary,
            },
          },
        }}
      >
        <ChartHorizontalIcon width={12} height={12} />
      </ToggleButton>
      <ToggleButton
        value="bar"
        aria-label="bar-chart"
        size="small"
        sx={{
          ...toggleButtonStyles,
          borderTopRightRadius: '2.4rem',
          borderBottomRightRadius: '2.4rem',
          '&:hover': {
            backgroundColor: theme.config.colors.primary_100,
          },
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: theme.config.colors.primary_100,
            'svg path': {
              fill: theme.config.colors.primary,
            },
          },
        }}
      >
        <PercentIcon width={12} height={12} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

ChartToggle.propTypes = {
  activeView: PropTypes.oneOf(['line', 'bar']).isRequired,
  onToggle: PropTypes.func.isRequired,
};
